import React from "react";
import { URLimage } from "../utils/varaibleFetch";
import { UrlPeintureDigital } from "../utils/varaibleFetch";
import FetchArticles from "../utils/fetcharticle";
import ArtworkGrid from "./artwork/ArtworkGrid";

interface Props {
  categorieUrl: string;
  title: string;
  presentation: string;
  text: string;
}

const FetchOeuvreByCategorie: React.FC<Props> = ({ categorieUrl, title, presentation, text }) => {

  const { articles, isLoading } = FetchArticles(UrlPeintureDigital, categorieUrl);

  return (
    <div className="category-page">
      <section className="category-page__intro">
        <p className="mono-label">Collection</p>
        <h1 className="art-title neon-title">{title}</h1>
        <div className="surface-panel category-page__copy">
          <h2>{presentation}</h2>
          <p>{text}</p>
        </div>
      </section>

      <section className="category-page__gallery" aria-label={`Oeuvres ${title}`}>
        <ArtworkGrid artworks={articles} imageBaseUrl={URLimage} isLoading={isLoading} />
      </section>

    </div>
  );
};

export default FetchOeuvreByCategorie
